export default "__VITE_ASSET__DcyW2kzK__"